export type BrandMarkPosition = "top-left" | "top-right" | "bottom-left" | "bottom-right";

export interface BrandMarkOptions {
  image?: string;
  /** Affiché à droite du logo. */
  text?: string;
  href?: string;
  /** Texte alternatif du logo, et infobulle du lien. */
  label?: string;
  /** Par défaut : "bottom-right", sous `ZoomControl` et les boutons empilés au-dessus. */
  position?: BrandMarkPosition;
  style?: Partial<CSSStyleDeclaration>;
}

export const BRAND_MARK_HEIGHT_PX = 20;

const POSITION_OFFSETS: Record<BrandMarkPosition, Partial<CSSStyleDeclaration>> = {
  "top-left": { top: "10px", left: "10px" },
  "top-right": { top: "10px", right: "10px" },
  "bottom-left": { bottom: "10px", left: "10px" },
  "bottom-right": { bottom: "10px", right: "10px" },
};

const DEFAULT_STYLE: Partial<CSSStyleDeclaration> = {
  position: "absolute",
  zIndex: "10",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  height: `${BRAND_MARK_HEIGHT_PX}px`,
  maxWidth: "min(240px, 60%)",
  gap: "6px",
};

const IMAGE_STYLE: Partial<CSSStyleDeclaration> = {
  display: "block",
  height: "100%",
  maxWidth: "120px",
  flexShrink: "0",
  objectFit: "contain",
};

export class BrandMark {
  private el: HTMLElement;

  constructor(container: HTMLElement, options: BrandMarkOptions) {
    this.el = options.href ? createLink(options.href, options.label) : document.createElement("div");
    this.el.className = "toka-brand-mark";
    Object.assign(this.el.style, DEFAULT_STYLE, POSITION_OFFSETS[options.position ?? "bottom-right"], options.style);

    if (options.image) {
      const image = document.createElement("img");
      image.src = options.image;
      image.alt = options.text ? "" : options.label ?? "";
      image.draggable = false;
      Object.assign(image.style, IMAGE_STYLE);
      this.el.appendChild(image);
    }

    if (options.text) {
      const text = document.createElement("span");
      text.className = "toka-brand-mark__text";
      text.textContent = options.text;
      this.el.appendChild(text);
    }
    container.appendChild(this.el);
  }

  destroy(): void {
    this.el.remove();
  }
}

function createLink(href: string, label: string | undefined): HTMLAnchorElement {
  const link = document.createElement("a");
  link.href = href;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  if (label) link.title = label;
  return link;
}
